import store from '../store';

/**
 * Здесь лежит логика, которая будет полезна и актуальна для любого виджета.
 * Не должно быть завязок на определенные виджеты!
 */
export default {
    provide() {
        return {
            scrollToTop: this.scrollToTop,
            loadGroupedOffers: this.loadGroupedOffers,
        };
    },
    props: {
        store: {
            required: true,
            type: Object,
            default: () => store,
        },
        searchState: {
            type: Object,
            default: () => ({
                public: {},
                private: {},
            }),
        },
        componentId: {
            type: String,
            default: '',
        },
        /**
         * Мы сначала делаем append компонента на страницу и только потом прокидываем в него props'ы
         * => мы не должны отображать компонент, пока не будут переданы props'ы (а именно isComponentReady)
         */
        isComponentReady: {
            type: Boolean,
            default: false,
        },
        loadingByFilters: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        wrapperClasses() {
            return {
                'l-ss-c-root': true,
                'l-ss-c-is-custom': true,
                'l-ss-c-is-responsive': this.$screen.isResponsive,
                'l-ss-c-is-not-responsive': this.$screen.isResponsive === false,
                'l-ss-c-is-mobile': this.$screen.isMobile,
                [`l-ss-c-is-${this.$screen.device}`]: true,
            };
        },
        instance() {
            return this.$instances.find(instance => instance.id === this.componentId);
        },
        wrapperElement() {
            return this.instance?.$wrapper || null;
        },
        options() {
            return this.instance?.options || {};
        },
        isShowSignature() {
            return this.store.state.ui.isShowSignature;
        },
    },
    methods: {
        handlePageReload() {
            document.location.reload();
        },
        scrollToTop(options) {
            this.$emit('scroll-to-top', options);
        },
        loadGroupedOffers(event) {
            this.$emit('load-grouped-offers', event);
        },
        handleAddToCartClick(event) {
            event.currentQuery = this.query;
            event.isEmptyCompletions = this.requestCompletions.isEmpty;
            this.$emit('add-to-cart-click', event);
        },
        handleShowAllClickEvent(event) {
            event.isEmptyCompletions = this.requestCompletions.isEmpty;
            this.$emit('show-all-click', event);
        },
    },
};
